'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', 'IndustryService',
                function($scope, IndustryService) {
                    $scope.industries = [];
                    IndustryService.api.get({
                                                filters: [`'status' EQ 'ENABLED'`],
                                                sorts: ['npp:ASC', 'name:ASC'],
                                            }, (data) => $scope.industries = data._embedded);
                }];
